import { render, staticRenderFns } from "./SectionTenants.vue?vue&type=template&id=2cfc3d60&"
import script from "./SectionTenants.vue?vue&type=script&lang=js&"
export * from "./SectionTenants.vue?vue&type=script&lang=js&"
import style0 from "./SectionTenants.vue?vue&type=style&index=0&id=2cfc3d60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,AtomsCommonAtomTenants: require('/app/components/atoms/common/AtomTenants.vue').default})
